/**
 * Create Cart context for custom hook
 */
import { createContext } from 'react'

const DineInCartContext = createContext({
  cart: {},
  dineInCartId: '',
  inventoryStoreCode: '',
  inventoryStoreId: null,
  stagingCart: {},
  totalItems: 0,
  createCart: () => {},
  initCartForCartBadge: () => {},
  refreshCart: () => {},
  resetCart: () => {},
  updateCart: () => {}
})

export default DineInCartContext
